module.exports = __webpack_public_path__ + "img/residence.06ece131.png";